import { create } from "zustand";

type ServerStatus = "online" | "offline";

interface ServerStatusState {
  status: ServerStatus;
  setStatus: (status: ServerStatus) => void;
}

export const useServerStatusStore = create<ServerStatusState>((set) => ({
  status: "online",
  setStatus: (status) => set({ status }),
}));
